import { scrollToReveal } from '../../../shared/scroll';

// A short row with its top at half the display reads as centered — the shared
// reveal's stand-in for the old scrollIntoView block: 'center'.
const MEMBER_ROW_TOP_RATIO = 0.5;

// Scrolls the leaderboard row of an aggregate into view (Shared/scroll owns
// the iframe height sync and the eased cross-document animation).
// Deferred to the next animation frame so React's commit (batched updates
// flush at the microtask boundary) lands before the DOM is queried.
export const scrollToAggregate = (aggregateId) =>
  requestAnimationFrame(() => {
    const el = document.getElementById(aggregateId);
    if (el) scrollToReveal(el, { topRatio: MEMBER_ROW_TOP_RATIO });
  });

// The aggregate id the currently rendered event data displays for a member.
// Search results carry the aggregate of the member's own round, which is not
// the rendered row when another round (or its snapshot) is on screen — the
// member lookup resolves the row that actually exists.
export const aggregateIdForMember = (eventData, memberId) => {
  const memberIdStr = String(memberId);
  for (const aggregates of Object.values(eventData?.scopes || {})) {
    const match = (aggregates || []).find(agg => (agg.memberIds || []).includes(memberIdStr));
    if (match) return match.id;
  }
  return null;
};
